import type z from 'zod/v4'
import { relations } from 'drizzle-orm'
import { index, integer, pgTable, primaryKey, uuid } from 'drizzle-orm/pg-core'
import { createInsertSchema, createSelectSchema, createUpdateSchema } from 'drizzle-zod'

import { Lesson } from '../lesson'
import { Challenge } from './challenge'

export const ChallengeToLesson = pgTable(
  'challenge_to_lesson',
  {
    challengeId: uuid()
      .notNull()
      .references(() => Challenge.id, { onDelete: 'cascade' }),
    lessonId: uuid()
      .notNull()
      .references(() => Lesson.id, { onDelete: 'cascade' }),
    order: integer().notNull(), // Order of lesson within the challenge
  },
  (table) => [
    primaryKey({ columns: [table.challengeId, table.lessonId] }),
    index('challenge_to_lesson_challenge_idx').on(table.challengeId),
    index('challenge_to_lesson_lesson_idx').on(table.lessonId),
    index('challenge_to_lesson_order_idx').on(table.order),
  ],
)

export const challengeToLessonRelations = relations(ChallengeToLesson, ({ one }) => ({
  challenge: one(Challenge, {
    fields: [ChallengeToLesson.challengeId],
    references: [Challenge.id],
  }),
  lesson: one(Lesson, {
    fields: [ChallengeToLesson.lessonId],
    references: [Lesson.id],
  }),
}))

export const InsertChallengeToLessonSchema = createInsertSchema(ChallengeToLesson)
export const UpdateChallengeToLessonSchema = createUpdateSchema(ChallengeToLesson).partial()
export const SelectChallengeToLessonSchema = createSelectSchema(ChallengeToLesson)

export type InsertChallengeToLesson = typeof ChallengeToLesson.$inferInsert
export type UpdateChallengeToLesson = z.infer<typeof UpdateChallengeToLessonSchema>
export type SelectChallengeToLesson = typeof ChallengeToLesson.$inferSelect
